import React from 'react'
import Select from 'meinian-package/src/baseComponent/select'

const convert = (data) => {
  return data.map(item => ({
    label: item.name,
    value: item.id
  }))
}

export default ({ options, value, ...otherProps }) => {
  const _options = convert(options)
  return <Select
    data={_options}
    allowClear={false}
    value={value}
    {...otherProps}
  />
}
